import { calcRentPresentValue } from "web_myplann/Goals/Helpers/calcRentPresentValue";

export const calcRentToZeroTotal = (monthly: number, years: number): number =>
	Math.round(calcRentPresentValue(monthly, years * 12));
